<template>
    <div>
      <PageHeader style="width: 100vw; position: fixed; top: 0; z-index: 1000;" />
      
      <div class="jd-container" style="margin-top: 80px;">
        <!-- 搜索区域 -->
        <header class="jd-header">
          <div class="jd-search-bar">
            <div class="search-wrapper">
              <input
                type="text"
                v-model="searchText"
                placeholder="输入商品名称"
                @keyup.enter="handleSearch"
                class="search-input"
              />
              <button class="search-button" @click="handleSearch">
                <i class="icon-search"></i>
              </button>
            </div>
          </div>
        </header>
  
        <!-- 商品展示区 -->
        <main class="goods-container">
          <div class="goods-grid">
            <div
              v-for="(item, index) in computedGoodsData"
              :key="index"
              class="goods-card"
              @click="goDetail(item.id)"
            >
              <div class="goods-image-wrapper">
                <img 
                  v-if="item.images.length > 0"
                  :src="item.images[0]" 
                  class="goods-image" 
                  @error="handleImageError"
                />
                <div v-else class="image-placeholder">
                  <i class="el-icon-picture-outline"></i>
                  <span>暂无图片</span>
                </div>
              </div>
              <div class="goods-info">
                <h3 class="goods-title">{{ item.title }}</h3>
                <p class="goods-desc">{{ item.desc }}</p>
                <div class="price-section">
                  <span class="current-price">¥{{ item.price.toFixed(2) }}</span>
                  <span 
                    class="original-price"
                    v-if="item.originalPrice"
                  >¥{{ item.originalPrice.toFixed(2) }}</span>
                  <span 
                    class="discount"
                    v-if="item.computedDiscount"
                  >{{ item.computedDiscount }}折</span>
                </div>
                <div class="sales-info">
                  <span class="sales-count">
                    <el-tag type="info" size="mini">
                      <i class="el-icon-view"></i>
                    {{ item.views.toLocaleString() }}
                    </el-tag>
                    
                  </span>
                  <span class="shop-name"><el-tag type="warning" size="mini">{{ item.shop }}</el-tag></span>
                </div>
              </div>
            </div>
          </div>
        </main>
  
        <!-- 浮动按钮容器 -->
        <div class="float-buttons">
          <div 
            class="float-button cart-button"
            @click="goCart"
          >
            <i class="icon-cart"></i>
            我的购物车
          </div>
          <div 
            class="float-button sell-button"
            @click="handleSell"
          >
            <i class="icon-plus"></i> 
            我也要卖
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import PageHeader from '../components/PageHeader.vue'
  
  export default {
    components: {
      PageHeader
    },
    data() {
      return {
        token: sessionStorage.getItem('token'),
        searchText: "",
        goodsData: [
          {
            id: 1,
            title: "皇家狗粮 至尊挑选",
            desc: "麦富迪狗粮barf霸弗生骨肉冻干天然成犬粮2kg鲜鸡肉配方多元营养",
            price: 199,
            originalPrice: 209,
            views: 152000,
            shop: "个人卖家",
            images: [
              "https://picsum.photos/400/400?random=1",
              "https://picsum.photos/400/400?random=2"
            ]
          },
          {
            id: 2,
            title: "营养猫罐头",
            desc: "1500米深海鲟鱼，晒足180天",
            price: 29.,
            originalPrice: 39,
            views: 152000,
            shop: "匿名卖家",
            images: [
                "https://picsum.photos/400/400?random=2",
              "https://picsum.photos/400/400?random=1",
              
            ]
          },
          // 其他商品数据保持不变...
        ]
      }
    },
    computed: {
    computedGoodsData: function() {
      var self = this;
      return this.goodsData.map(function(item) {
        var newItem = JSON.parse(JSON.stringify(item)); // 深拷贝
        
        // 计算折扣
        if (newItem.originalPrice && newItem.originalPrice > 0) {
          var discountValue = (newItem.price / newItem.originalPrice * 10);
          var roundedDiscount = Math.round(discountValue * 10) / 10; // 保留1位小数
          
          // 只有折扣小于10折时才显示
          if (roundedDiscount < 10) {
            newItem.computedDiscount = roundedDiscount.toFixed(1);
          } else {
            newItem.computedDiscount = null;
          }
        } else {
          newItem.computedDiscount = null;
        }
        
        return newItem;
      });
    }
  },
    methods: {
      handleSearch() {
        if (!this.searchText.trim()) return
        console.log('搜索内容:', this.searchText)
        this.searchText = ""
      },
      handleSell() {
        if(this.token != null){
          this.$router.push("/sellGoods")
        }else{
          this.$message.error('未登录，请先登录')
        }
        
      },
      handleImageError(e) {
        e.target.style.display = 'none'
      },
      goDetail(goodsID){
        this.$router.push({path:'/detailGoodsPage',query:{id:goodsID}})
      },
      goCart() {
        
        if(this.token != null){
          this.$router.push('/carDialog')
        }else{
          this.$message.error('未登录，请先登录')
        }
        
      }
    }
  }
  </script>
  
  <style scoped>
  /* 容器样式 */
  .jd-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px 80px; /* 添加底部内边距防止内容被按钮遮挡 */
  }
  
  /* 搜索区域 */
  .jd-header {
    background: #ffffff;
    padding: 20px 0;
    margin: 20px 0;
    border-bottom: 1px solid #ebeef5;
  }
  
  .search-wrapper {
    max-width: 800px;
    margin: 0 auto;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #ffffff;
  }
  
  .search-input {
    width: 100%;
    height: 48px;
    padding: 0 50px 0 20px;
    border: none;
    font-size: 14px;
    color: #606266;
    background: transparent;
  }
  
  .search-button {
    position: absolute;
    right: 0;
    top: 0;
    width: 48px;
    height: 48px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .icon-search {
    width: 20px;
    height: 20px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%236066ff'%3E%3Cpath d='M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3C/svg%3E")
      center/contain no-repeat;
  }
  
  /* 商品列表 */
  .goods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
    padding: 20px 0;
  }
  
  .goods-card {
    background: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #ebeef5;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
  }
  
  .goods-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 16px 0 rgba(0,0,0,0.1);
  }
  
  .goods-image-wrapper {
    position: relative;
    padding-top: 100%;
    background: #f5f7fa;
    overflow: hidden;
  }
  
  .goods-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .goods-card:hover .goods-image {
    transform: scale(1.05);
  }
  
  .image-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    background: #f0f2f5;
  }
  
  .goods-info {
    padding: 16px;
  }
  
  .goods-title {
    font-size: 14px;
    color: #303133;
    margin: 0 0 8px;
    line-height: 1.4;
    height: 40px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .price-section {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 12px;
  }
  
  .current-price {
    color: #409EFF;
    font-size: 18px;
    font-weight: 600;
  }
  
  .original-price {
    color: #c0c4cc;
    font-size: 12px;
    text-decoration: line-through;
  }
  
  /* 浮动按钮 */
  .float-buttons {
    position: fixed;
    right: 40px;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 2000;
  }
  
  .float-button {
    display: flex;
    align-items: center;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s;
  }
  
  .sell-button {
    background: #409EFF;
    color: #fff;
  }
  
  .cart-button {
    background: #67C23A;
    color: #fff;
  }
  
  .float-button:hover {
    transform: translateY(-2px);
  }
  
  .icon-cart {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E")
      center/contain no-repeat;
  }
  
  @media (max-width: 768px) {
    .jd-container {
      padding: 0 10px;
    }
  
    .goods-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }
  
    .float-buttons {
      right: 16px;
      bottom: 16px;
    }
    
    .float-button {
      padding: 10px 16px;
      font-size: 13px;
    }
  }
  </style>